import { INVOICE_PAYER_TYPES_BANK } from 'utils/constants/invoice';

import { Requirements } from 'app/routes';

import { resetCreatePayerInfo, setAvailablePayerTypes } from 'store/models/payerCreate';

const PayerCreateRequirements: Partial<Requirements> = {
    resolve: () => {
        return [resetCreatePayerInfo(null), setAvailablePayerTypes(INVOICE_PAYER_TYPES_BANK)];
    },
};

export default PayerCreateRequirements;
